<template>
  <v-dialog persistent v-model="dialogFollowers" max-width="450">
    <v-card max-width="450" class="mx-auto">
      <div class="px-3 pt-3 mb-0 d-flex justify-end">
        <v-icon class="cursor-pointer" @click="closeFollowerList"
          >mdi-close</v-icon
        >
      </div>
      <v-list class="scroll-container">
        <div v-if="!followerList.length">
          <v-card-title>
            <span class="gc-text-h6 mb-1">{{ lang.profile.noFollowers }}</span>
          </v-card-title>
        </div>
        <div v-else>
          <div
            v-for="(item, index) in displayedFollowers"
            :key="index"
            class="px-2"
          >
            <v-list-item dense>
              <v-list-item-avatar
                width="30"
                height="30"
                min-height="30"
                min-width="30"
                color="grey"
              >
                <v-img
                  v-if="item.profileImageUrl"
                  :src="item.profileImageUrl"
                  :alt="item.userFullName"
                  :lazy-src="require('../../assets/images/lazy-loading.png')"
                ></v-img>
                <div v-else>
                  {{ getFullNameInitials(item.userFullName) }}
                </div>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ item.userFullName }}</v-list-item-title>
              </v-list-item-content>
              <v-icon class="subtitle-1">mdi-account-check</v-icon>
            </v-list-item>
            <v-divider
              v-if="displayedFollowers.length - 1 != index"
            ></v-divider>
          </div>
          <!-- Observer Trigger -->
          <div ref="loadMoreTrigger" class="load-more-trigger"></div>
        </div>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
import helpers from "@/plugins/helpers";

export default {
  name: "FollowersDialog",
  props: {
    followerList: {
      type: Array,
      default: () => [],
    },
    dialogFollowers: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      displayedFollowers: [],
      itemsPerPage: 10,
      observer: null,
    };
  },
  watch: {
    dialogFollowers(val) {
      if (val) {
        this.loadInitialFollowers();
        this.$nextTick(() => this.setupIntersectionObserver());
      }
    },
  },
  methods: {
    closeFollowerList() {
      this.$emit("closeFollowerList");
    },
    getFullNameInitials(name) {
      return helpers.getFullNameInitials(name);
    },
    loadInitialFollowers() {
      this.displayedFollowers = this.followerList.slice(0, this.itemsPerPage);
    },
    loadMore() {
      if (this.displayedFollowers.length >= this.followerList.length) return;

      const nextItems = this.followerList.slice(
        this.displayedFollowers.length,
        this.displayedFollowers.length + this.itemsPerPage
      );
      this.displayedFollowers = [...this.displayedFollowers, ...nextItems];
    },
    setupIntersectionObserver() {
      if (this.observer) this.observer.disconnect();

      this.$nextTick(() => {
        const trigger = this.$refs.loadMoreTrigger;
        if (!trigger) return;

        this.observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            this.loadMore();
          }
        });

        this.observer.observe(trigger);
      });
    },
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  },
  computed: {
    lang() {
      return this.$store.state.langObj || {};
    },
  },
};
</script>

<style>
.scroll-container {
  max-height: 400px;
  overflow-y: auto;
}
.load-more-trigger {
  height: 20px;
}
</style>
